'use strict';

var List = require('./List');
var ListOld = require('../../deprecated/views/ListOld');
var Select = require('./Select');
var getUserListItems = require('./list-items/user-list-items');
var getManageListItems = require('./list-items/manage-list-items');
var getMarketplaceListItems = require('./list-items/marketplace-list-items');
var getLanguageListItems = require('./list-items/language-list-items');
var getCurrencyListItems = require('./list-items/currency-list-items');
var getLanguageSelectOptions = require('./list-items/language-select-options');
var getCompanyListItems = require('./list-items/company-list-items');
var adSearchTemplate = require('../templates/ad-search-form.tpl');
var languageFunctionTemplate = require('../templates/functions/language-function.tpl');
var companyFunctionTemplate = require('../templates/functions/company-function.tpl');
var currencyFunctionTemplate = require('../templates/functions/currency-function.tpl');

function getRenderList(depsArgs) {
	var userListItems = getUserListItems.renderUserListItems(depsArgs);
	var manageListItems = getManageListItems.renderManageListItems(depsArgs);
	var marketplaceListItems = getMarketplaceListItems.renderMarketplaceListItems(depsArgs);
	var languageListItems = getLanguageListItems.renderLanguageListItems(depsArgs);
	var languageSelectItems = getLanguageSelectOptions.renderLanguageSelectOptions(depsArgs);
	var companyListItems = getCompanyListItems.renderCompanyListItems(depsArgs);
	var currencyListItems = getCurrencyListItems.renderCurrencyListItems(depsArgs);

	function getLocaleTags(config) {
		if (!config.CHANNEL_SETTINGS || !config.CHANNEL_SETTINGS.localeTags) {
			return '';
		}
		var locales = config.CHANNEL_SETTINGS.localeTags;
		if (locales.length === 1) return '';

		return locales;
	}

	return {

		renderUserList: function render(config, deps) {
			return (new List({
				list: [
					userListItems.renderSubscriptionListItem(config, deps),
					userListItems.renderProfileListItem(config, deps),
					userListItems.renderCompanyListItem(config, deps),
					userListItems.renderSettingsListItem(config, deps),
					marketplaceListItems.renderLogOutListItem(config, deps)
				].join(''),
				className: 'ad-component_list--user-list'
			})).render(config, deps);
		},

		renderManageList: function render(config, deps) {
			return (new List({
				list: [
					manageListItems.renderAccountListItem(config, deps),
					manageListItems.renderInsightListItem(config, deps),
					manageListItems.renderChannelListItem(config, deps),
					manageListItems.renderCorporateListItem(config, deps),
					manageListItems.renderDeveloperListItem(config, deps),
					manageListItems.renderResellerListItem(config, deps),
					manageListItems.renderSuperuserListItem(config, deps)
				].join(''),
				className: 'ad-component_list--manage-list manage-links'
			})).render(config, deps);
		},

		renderManageLinksOld: function render(config, deps) {
			return (new ListOld({
				list: [
					manageListItems.renderAccountListItem(config, deps),
					manageListItems.renderChannelListItem(config, deps),
					manageListItems.renderCorporateListItem(config, deps),
					manageListItems.renderDeveloperListItem(config, deps),
					manageListItems.renderResellerListItem(config, deps),
					manageListItems.renderSuperuserListItem(config, deps)
				].join(''),
				className: 'ad-component_list--manage-list manage-links'
			})).render(config, deps);
		},

		renderLanguageList: function render(config, deps) {
			if (!getLocaleTags(config)) return '';

			return languageFunctionTemplate + (new List({
				list: languageListItems.getLanguageListItems(config, deps),
				className: 'ad-component_list--language-list language-links'
			})).render(config, deps);
		},

		renderLanguageSelect: function render(config, deps) {
			if (!getLocaleTags(config)) return '';

			return languageFunctionTemplate + (new Select({
				list: languageSelectItems.getLanguageSelectOptions(config, deps),
				className: 'ad-component_list--language-select language-select',
				changeFunction: 'changeLanguage(value)'
			})).render(config, deps);
		},

		renderSearch: function render() {
			return adSearchTemplate;
		},

		renderCompanyList: function render(config, deps) {
			var user = config.UserInfo;
			var memberships = config.memberships;
			var result = '';
			var companyFunctionTpl = !config.jQueryDisabled ? companyFunctionTemplate : '';

			if (user && memberships && memberships.length > 1) {
				return companyFunctionTpl + (new List({
					list: companyListItems.getCompanyListItems(config, deps),
					className: 'ad-component_list--company-list company-links'
				})).render(config, deps);
			}
			return result;
		},

		renderCurrencyList: function render(config, deps) {
			return currencyFunctionTemplate + (new List({
				list: currencyListItems.getCurrencyListItems(config, deps),
				className: 'currency-links'
			})).render(config, deps);
		}
	};
}

module.exports = {
	getRenderList: getRenderList
};



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/views/all-lists.js
// module id = 18
// module chunks = 0